module.exports = ".navbar {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.navbar-default .navbar-nav > li > a.logout,\r\n .navbar-default .navbar-nav > li > a.login {\r\n    display: inline-block;\r\n}\r\n\r\n.navbar-default,\r\n.navbar-default .navbar-collapse,\r\n.navbar-default .navbar-form {\r\n    border-color: #e8f1f2;\r\n}\r\n\r\n.header-bar {\r\n    height: 50px;\r\n    background-image: url(\"/assets/header-image.jpg\");\r\n    background-color: #006494;\r\n    background-size:cover;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/header/header.component.css
// module id = ./src/app/components/shared/header/header.component.css
// module chunks = main